<template>
  <SendModal
    :object-to-send="props.content"
    :hub-slug="hubSlug"
    :content-slug="contentSlug"
    :title="$t('content.send')"
  >
    <template #object-image>
      <img
        class="aspect-[3/2] object-cover rounded-md h-53"
        :src="props.content.imageUrl"
        :alt="$t('content.alt')"
      />
    </template>
    <div class="flex gap-3 items-center text-secondary">
      <ContentTypeIcon
        :content-type="props.content.type"
        :size="IconSize['2XL']"
      />
      <span class="text-sm font-semibold">
        {{ ContentTypeLabelMap[props.content.type] }}
      </span>
    </div>
  </SendModal>
</template>

<script setup lang="ts">
import { IconSize } from '@exfluential/ui';
import { useContentTypeLabelMap } from '~/api/contents';
import { ContentTypeIcon } from '~/components/content-type-icon';
import { SendModal } from '~/pages/_components/send-modal';

type Props = {
  hubSlug?: string;
  contentSlug?: string;
  content: Record<string, unknown>;
};
const props = defineProps<Props>();

const ContentTypeLabelMap = useContentTypeLabelMap();
</script>
